// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { bundlesSearchParamsSchema } from '@/bundle/api/types';
import { BundlesListing } from '@/bundle/components/bundles-listing';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Route configuration for the bundles index page.
 * Supports search, archived filter, sorting, and pagination via URL params.
 */
export const Route = createFileRoute('/_app/catalog/bundles/')({
  component: BundlesIndexRoute,
  validateSearch: bundlesSearchParamsSchema,
});

function BundlesIndexRoute() {
  const searchParams = Route.useSearch();

  const initialBundleName = searchParams.new
    ? decodeURIComponent(searchParams.new)
    : undefined;

  return (
    <BundlesListing
      searchParams={searchParams}
      initialBundleName={initialBundleName}
    />
  );
}
